import { atom } from "jotai";
import { fetchBase } from "./BaseApi";
import { State } from "./State";

const uri = "api/users/investment-header-message";

export type UserInvestmentHeaderMessage = {
  conditionCode: string;
  characterPosition: "left" | "right";
  characterImageName: string;
  message: string;
  messageSegments?: UserInvestmentHeaderMessageSegment[];
};

export type UserInvestmentHeaderMessageSegment = {
  text: string;
  emphasis: boolean;
  emphasisColor: "green" | "orange" | null;
};

export type FetchUserInvestmentHeaderMessageParam = {
  pointOwnerId?: number;
};

export const fetchUserInvestmentHeaderMessageAtom =
  atom<State<UserInvestmentHeaderMessage> | null>(null);

export const fetchUserInvestmentHeaderMessage = () => {
  return fetchBase<
    UserInvestmentHeaderMessage,
    FetchUserInvestmentHeaderMessageParam
  >(uri, fetchUserInvestmentHeaderMessageAtom);
};
